/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/root/modal/modal.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '@angular/core/src/linker/view_type';
import * as import6 from '@angular/core/src/change_detection/constants';
import * as import7 from '@angular/core/src/linker/component_factory';
import * as import8 from '../../../../../public/upgrade/root/modal/modal.service';
import * as import9 from '@angular/core/src/linker/view_container';
import * as import10 from '@angular/core/src/change_detection/change_detection_util';
import * as import11 from '@ngx-translate/core/src/translate.pipe';
import * as import12 from '@ngx-translate/core/src/translate.service';
import * as import13 from '../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import14 from '../../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import15 from '../../../../node_modules/@angular/forms/src/directives/validators.ngfactory';
import * as import16 from '../../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import17 from '../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import18 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import19 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import20 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import21 from '@angular/core/src/linker/element_ref';
import * as import22 from '@angular/core/src/linker/template_ref';
import * as import23 from '@angular/forms/src/directives/default_value_accessor';
import * as import24 from '@angular/forms/src/directives/validators';
import * as import25 from '@angular/forms/src/validators';
import * as import26 from '@angular/forms/src/directives/control_value_accessor';
import * as import27 from '@angular/forms/src/directives/ng_model';
import * as import28 from '@angular/forms/src/directives/ng_control';
import * as import29 from '@angular/forms/src/directives/ng_control_status';
import * as import30 from '@angular/common/src/directives/ng_if';
import * as import31 from '@angular/common/src/directives/ng_class';
export class Wrapper_ModalComponent {
  /*private*/ _eventHandler:Function;
  context:import0.ModalComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any) {
    this._changed = false;
    this.context = new import0.ModalComponent(p0);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_ModalComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_ModalComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.ModalComponent>;
  _ModalComponent_0_3:Wrapper_ModalComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_ModalComponent_Host0,renderType_ModalComponent_Host,import5.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'modal',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_ModalComponent0(this.viewUtils,this,0,this._el_0);
    this._ModalComponent_0_3 = new Wrapper_ModalComponent(this.injectorGet(import8.ModalService,this.parentIndex));
    this.compView_0.create(this._ModalComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import7.ComponentRef_<any>(0,this,this._el_0,this._ModalComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.ModalComponent) && (0 === requestNodeIndex))) { return this._ModalComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ModalComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const ModalComponentNgFactory:import7.ComponentFactory<import0.ModalComponent> = new import7.ComponentFactory<import0.ModalComponent>('modal',View_ModalComponent_Host0,import0.ModalComponent);
const styles_ModalComponent:any[] = ([] as any[]);
class View_ModalComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import9.ViewContainer) {
    super(View_ModalComponent1,renderType_ModalComponent,import5.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import10.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','modal-default-info-parrafo'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    var tmp_2_0:any = (null as any);
    const currVal_2:any = import3.inlineInterpolate(1,'\n            ',(((tmp_2_0 = this.parentView.context.getModal()) == null)? (null as any): tmp_2_0.getLabel()),'\n        ');
    if (import3.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_ModalComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import11.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import9.ViewContainer) {
    super(View_ModalComponent3,renderType_ModalComponent,import5.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import10.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','validation-msg'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import10.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('modal.ADDITIONAL_INSTRUCTIONS.REQUIRED')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_ModalComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import11.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import9.ViewContainer) {
    super(View_ModalComponent4,renderType_ModalComponent,import5.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import10.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','validation-msg'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import10.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('common.INPUT_INVALID_TEXT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_ModalComponent2 extends import1.AppView<any> {
  _el_0:any;
  _NgClass_0_3:import13.Wrapper_NgClass;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _DefaultValueAccessor_4_3:import14.Wrapper_DefaultValueAccessor;
  _MinLengthValidator_4_4:import15.Wrapper_MinLengthValidator;
  _MaxLengthValidator_4_5:import15.Wrapper_MaxLengthValidator;
  _NG_VALIDATORS_4_6:any[];
  _NG_VALUE_ACCESSOR_4_7:any[];
  _NgModel_4_8:import16.Wrapper_NgModel;
  _NgControl_4_9:any;
  _NgControlStatus_4_10:import17.Wrapper_NgControlStatus;
  _text_5:any;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _vc_7:import9.ViewContainer;
  _TemplateRef_7_5:any;
  _NgIf_7_6:import18.Wrapper_NgIf;
  _text_8:any;
  _anchor_9:any;
  /*private*/ _vc_9:import9.ViewContainer;
  _TemplateRef_9_5:any;
  _NgIf_9_6:import18.Wrapper_NgIf;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _map_30:any;
  /*private*/ _expr_31:any;
  _pipe_translate_0:import11.TranslatePipe;
  /*private*/ _expr_33:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import9.ViewContainer) {
    super(View_ModalComponent2,renderType_ModalComponent,import5.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_30 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'eva-3-validation -invalid -bottom-right': p0};
    });
    this._expr_31 = import10.UNINITIALIZED;
    this._expr_33 = import10.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-input -lg'),(null as any));
    this._NgClass_0_3 = new import13.Wrapper_NgClass(this.parentView.parentView.injectorGet(import19.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import20.KeyValueDiffers,this.parentView.parentIndex),new import21.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','input-container'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'input',new import3.InlineArray16(10,'class','input-tag modal-default-info-input','id','modal-input-additional-instructions','maxlength','100','minlength','1','type','text'),(null as any));
    this._DefaultValueAccessor_4_3 = new import14.Wrapper_DefaultValueAccessor(this.renderer,new import21.ElementRef(this._el_4));
    this._MinLengthValidator_4_4 = new import15.Wrapper_MinLengthValidator();
    this._MaxLengthValidator_4_5 = new import15.Wrapper_MaxLengthValidator();
    this._NG_VALIDATORS_4_6 = [
      this._MinLengthValidator_4_4.context,
      this._MaxLengthValidator_4_5.context
    ]
    ;
    this._NG_VALUE_ACCESSOR_4_7 = [this._DefaultValueAccessor_4_3.context];
    this._NgModel_4_8 = new import16.Wrapper_NgModel((null as any),this._NG_VALIDATORS_4_6,(null as any),this._NG_VALUE_ACCESSOR_4_7);
    this._NgControl_4_9 = this._NgModel_4_8.context;
    this._NgControlStatus_4_10 = new import17.Wrapper_NgControlStatus(this._NgControl_4_9);
    this._text_5 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_7 = new import9.ViewContainer(7,2,this,this._anchor_7);
    this._TemplateRef_7_5 = new import22.TemplateRef_(this,7,this._anchor_7);
    this._NgIf_7_6 = new import18.Wrapper_NgIf(this._vc_7.vcRef,this._TemplateRef_7_5);
    this._text_8 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._anchor_9 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_9 = new import9.ViewContainer(9,2,this,this._anchor_9);
    this._TemplateRef_9_5 = new import22.TemplateRef_(this,9,this._anchor_9);
    this._NgIf_9_6 = new import18.Wrapper_NgIf(this._vc_9.vcRef,this._TemplateRef_9_5);
    this._text_10 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_11 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','modal-default-info-char-left'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray8(8,'keydown',(null as any),'ngModelChange',(null as any),'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_4));
    this._NgModel_4_8.subscribe(this,this.eventHandler(this.handleEvent_4),true);
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._anchor_7,
      this._text_8,
      this._anchor_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.DefaultValueAccessor) && (4 === requestNodeIndex))) { return this._DefaultValueAccessor_4_3.context; }
    if (((token === import24.MinLengthValidator) && (4 === requestNodeIndex))) { return this._MinLengthValidator_4_4.context; }
    if (((token === import24.MaxLengthValidator) && (4 === requestNodeIndex))) { return this._MaxLengthValidator_4_5.context; }
    if (((token === import25.NG_VALIDATORS) && (4 === requestNodeIndex))) { return this._NG_VALIDATORS_4_6; }
    if (((token === import26.NG_VALUE_ACCESSOR) && (4 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_4_7; }
    if (((token === import27.NgModel) && (4 === requestNodeIndex))) { return this._NgModel_4_8.context; }
    if (((token === import28.NgControl) && (4 === requestNodeIndex))) { return this._NgControl_4_9; }
    if (((token === import29.NgControlStatus) && (4 === requestNodeIndex))) { return this._NgControlStatus_4_10.context; }
    if (((token === import22.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import30.NgIf) && (7 === requestNodeIndex))) { return this._NgIf_7_6.context; }
    if (((token === import22.TemplateRef) && (9 === requestNodeIndex))) { return this._TemplateRef_9_5; }
    if (((token === import30.NgIf) && (9 === requestNodeIndex))) { return this._NgIf_9_6.context; }
    if (((token === import31.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 14)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import10.ValueUnwrapper();
    const currVal_0_0_0:any = 'eva-3-input -lg';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_30((this.parentView.context.getModal().showRequiredErrorValidation || this.parentView.context.getModal().showInvalidErrorValidation));
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this._DefaultValueAccessor_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_4_1_0:any = '1';
    this._MinLengthValidator_4_4.check_minlength(currVal_4_1_0,throwOnChange,false);
    this._MinLengthValidator_4_4.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_4_2_0:any = '100';
    this._MaxLengthValidator_4_5.check_maxlength(currVal_4_2_0,throwOnChange,false);
    this._MaxLengthValidator_4_5.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_4_3_0:any = this.parentView.context.getModal().additionalInstructions;
    this._NgModel_4_8.check_model(currVal_4_3_0,throwOnChange,false);
    this._NgModel_4_8.ngDoCheck(this,this._el_4,throwOnChange);
    this._NgControlStatus_4_10.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_7_0_0:any = this.parentView.context.getModal().showRequiredErrorValidation;
    this._NgIf_7_6.check_ngIf(currVal_7_0_0,throwOnChange,false);
    this._NgIf_7_6.ngDoCheck(this,this._anchor_7,throwOnChange);
    const currVal_9_0_0:any = this.parentView.context.getModal().showInvalidErrorValidation;
    this._NgIf_9_6.check_ngIf(currVal_9_0_0,throwOnChange,false);
    this._NgIf_9_6.ngDoCheck(this,this._anchor_9,throwOnChange);
    this._vc_7.detectChangesInNestedViews(throwOnChange);
    this._vc_9.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_31:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('modal.ADDITIONAL_INSTRUCTIONS.PLACEHOLDER')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_31,currVal_31))) {
      this.renderer.setElementProperty(this._el_4,'placeholder',currVal_31);
      this._expr_31 = currVal_31;
    }
    this._MinLengthValidator_4_4.checkHost(this,this,this._el_4,throwOnChange);
    this._MaxLengthValidator_4_5.checkHost(this,this,this._el_4,throwOnChange);
    this._NgControlStatus_4_10.checkHost(this,this,this._el_4,throwOnChange);
    const currVal_33:any = import3.inlineInterpolate(1,'',this.parentView.context.getModal().getCharsLeftLabel(),'');
    if (import3.checkBinding(throwOnChange,this._expr_33,currVal_33)) {
      this.renderer.setText(this._text_13,currVal_33);
      this._expr_33 = currVal_33;
    }
  }
  destroyInternal():void {
    this._vc_7.destroyNestedViews();
    this._vc_9.destroyNestedViews();
    this._NgModel_4_8.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 7)) { return new View_ModalComponent3(this.viewUtils,this,7,this._anchor_7,this._vc_7); }
    if ((nodeIndex == 9)) { return new View_ModalComponent4(this.viewUtils,this,9,this._anchor_9,this._vc_9); }
    return (null as any);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_4_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'keydown')) {
      const pd_sub_0:any = ((<any>this.parentView.context.getModal().changed()) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'ngModelChange')) {
      const pd_sub_1:any = ((<any>(this.parentView.context.getModal().additionalInstructions = $event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_ModalComponent5 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  /*private*/ _expr_14:any;
  _pipe_translate_0:import11.TranslatePipe;
  /*private*/ _expr_16:any;
  _pipe_translate_1:import11.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import9.ViewContainer) {
    super(View_ModalComponent5,renderType_ModalComponent,import5.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_14 = import10.UNINITIALIZED;
    this._expr_16 = import10.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','col -md-12 -md-6'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'dsp-button',new import3.InlineArray8(8,'class','modal-default-info-buttons','qadata','save','size','md','variation','primary'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_4,'dsp-button',new import3.InlineArray8(6,'qadata','cancel','size','md','variation','link'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._text_12 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_6,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_6));
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_9,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_9));
    this._pipe_translate_1 = new import11.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._text_13
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import10.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_14:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('common.SAVE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_14,currVal_14))) {
      this.renderer.setText(this._text_7,currVal_14);
      this._expr_14 = currVal_14;
    }
    valUnwrapper.reset();
    const currVal_16:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('common.CANCEL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_16,currVal_16))) {
      this.renderer.setText(this._text_10,currVal_16);
      this._expr_16 = currVal_16;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_6(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.getModal().emitAdditionalInstructions()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_9(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.getModal().hide(false)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_ModalComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  /*private*/ _expr_17:any;
  _pipe_translate_0:import11.TranslatePipe;
  /*private*/ _expr_19:any;
  _pipe_translate_1:import11.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import9.ViewContainer) {
    super(View_ModalComponent6,renderType_ModalComponent,import5.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_17 = import10.UNINITIALIZED;
    this._expr_19 = import10.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-lg'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','-md-12'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'a',new import3.InlineArray4(4,'class','eva-btn -md -primary -loader','qadata','save'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'em',new import3.InlineArray2(2,'class','btn-text'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_2,'a',new import3.InlineArray4(4,'class','eva-btn link -md','qadata','cancel'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'em',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_10,'\n                ',(null as any));
    this._text_15 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_16 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_4));
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_10,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_10));
    this._pipe_translate_1 = new import11.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._text_16
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import10.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_17:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('modal.BUTTON_YES_IM_SURE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_17,currVal_17))) {
      this.renderer.setText(this._text_7,currVal_17);
      this._expr_17 = currVal_17;
    }
    valUnwrapper.reset();
    const currVal_19:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('modal.BUTTON_NO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_19,currVal_19))) {
      this.renderer.setText(this._text_13,currVal_19);
      this._expr_19 = currVal_19;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.getModal().hide(true)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_10(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.getModal().hide(false)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_ModalComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_ModalComponent,{});
export class View_ModalComponent0 extends import1.AppView<import0.ModalComponent> {
  _el_0:any;
  _NgClass_0_3:import13.Wrapper_NgClass;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _anchor_21:any;
  /*private*/ _vc_21:import9.ViewContainer;
  _TemplateRef_21_5:any;
  _NgIf_21_6:import18.Wrapper_NgIf;
  _text_22:any;
  _anchor_23:any;
  /*private*/ _vc_23:import9.ViewContainer;
  _TemplateRef_23_5:any;
  _NgIf_23_6:import18.Wrapper_NgIf;
  _text_24:any;
  _anchor_25:any;
  /*private*/ _vc_25:import9.ViewContainer;
  _TemplateRef_25_5:any;
  _NgIf_25_6:import18.Wrapper_NgIf;
  _text_26:any;
  _anchor_27:any;
  /*private*/ _vc_27:import9.ViewContainer;
  _TemplateRef_27_5:any;
  _NgIf_27_6:import18.Wrapper_NgIf;
  _text_28:any;
  _text_29:any;
  _map_43:any;
  /*private*/ _expr_44:any;
  _pipe_translate_0:import11.TranslatePipe;
  /*private*/ _expr_46:any;
  _pipe_translate_1:import11.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_ModalComponent0,renderType_ModalComponent,import5.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
    this._map_43 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-show-modal': p0};
    });
    this._expr_44 = import10.UNINITIALIZED;
    this._expr_46 = import10.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray8(6,'class','eva-3-modal','qadata','modal-dialog','style','z-index: 10'),(null as any));
    this._NgClass_0_3 = new import13.Wrapper_NgClass(this.parentView.injectorGet(import19.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import20.KeyValueDiffers,this.parentIndex),new import21.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','modal-header'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','modal-close eva-3-icon-close'),(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','modal-title-container'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'h4',new import3.InlineArray2(2,'class','modal-title eva-3-h4 ng-scope'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n        ',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','modal-content eva-modal-container'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n        ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_13,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n            ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'p',new import3.InlineArray2(2,'class','modal-default-info-desc'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_15,'\n        ',(null as any));
    this._text_20 = this.renderer.createText(this._el_13,'\n        ',(null as any));
    this._anchor_21 = this.renderer.createTemplateAnchor(this._el_13,(null as any));
    this._vc_21 = new import9.ViewContainer(21,13,this,this._anchor_21);
    this._TemplateRef_21_5 = new import22.TemplateRef_(this,21,this._anchor_21);
    this._NgIf_21_6 = new import18.Wrapper_NgIf(this._vc_21.vcRef,this._TemplateRef_21_5);
    this._text_22 = this.renderer.createText(this._el_13,'\n        ',(null as any));
    this._anchor_23 = this.renderer.createTemplateAnchor(this._el_13,(null as any));
    this._vc_23 = new import9.ViewContainer(23,13,this,this._anchor_23);
    this._TemplateRef_23_5 = new import22.TemplateRef_(this,23,this._anchor_23);
    this._NgIf_23_6 = new import18.Wrapper_NgIf(this._vc_23.vcRef,this._TemplateRef_23_5);
    this._text_24 = this.renderer.createText(this._el_13,'\n        ',(null as any));
    this._anchor_25 = this.renderer.createTemplateAnchor(this._el_13,(null as any));
    this._vc_25 = new import9.ViewContainer(25,13,this,this._anchor_25);
    this._TemplateRef_25_5 = new import22.TemplateRef_(this,25,this._anchor_25);
    this._NgIf_25_6 = new import18.Wrapper_NgIf(this._vc_25.vcRef,this._TemplateRef_25_5);
    this._text_26 = this.renderer.createText(this._el_13,'\n        ',(null as any));
    this._anchor_27 = this.renderer.createTemplateAnchor(this._el_13,(null as any));
    this._vc_27 = new import9.ViewContainer(27,13,this,this._anchor_27);
    this._TemplateRef_27_5 = new import22.TemplateRef_(this,27,this._anchor_27);
    this._NgIf_27_6 = new import18.Wrapper_NgIf(this._vc_27.vcRef,this._TemplateRef_27_5);
    this._text_28 = this.renderer.createText(this._el_13,'\n    ',(null as any));
    this._text_29 = this.renderer.createText(this._el_0,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_0));
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_2));
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_4));
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_13,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_13));
    this._pipe_translate_1 = new import11.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._anchor_21,
      this._text_22,
      this._anchor_23,
      this._text_24,
      this._anchor_25,
      this._text_26,
      this._anchor_27,
      this._text_28,
      this._text_29
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (21 === requestNodeIndex))) { return this._TemplateRef_21_5; }
    if (((token === import30.NgIf) && (21 === requestNodeIndex))) { return this._NgIf_21_6.context; }
    if (((token === import22.TemplateRef) && (23 === requestNodeIndex))) { return this._TemplateRef_23_5; }
    if (((token === import30.NgIf) && (23 === requestNodeIndex))) { return this._NgIf_23_6.context; }
    if (((token === import22.TemplateRef) && (25 === requestNodeIndex))) { return this._TemplateRef_25_5; }
    if (((token === import30.NgIf) && (25 === requestNodeIndex))) { return this._NgIf_25_6.context; }
    if (((token === import22.TemplateRef) && (27 === requestNodeIndex))) { return this._TemplateRef_27_5; }
    if (((token === import30.NgIf) && (27 === requestNodeIndex))) { return this._NgIf_27_6.context; }
    if (((token === import31.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 29)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import10.ValueUnwrapper();
    const currVal_0_0_0:any = 'eva-3-modal';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_43(this.context.getModal().isModalVisible());
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_21_0_0:any = this.context.getModal().isAdditionalPickupPointModal();
    this._NgIf_21_6.check_ngIf(currVal_21_0_0,throwOnChange,false);
    this._NgIf_21_6.ngDoCheck(this,this._anchor_21,throwOnChange);
    const currVal_23_0_0:any = this.context.getModal().isAdditionalPickupPointModal();
    this._NgIf_23_6.check_ngIf(currVal_23_0_0,throwOnChange,false);
    this._NgIf_23_6.ngDoCheck(this,this._anchor_23,throwOnChange);
    const currVal_25_0_0:any = this.context.getModal().isAdditionalPickupPointModal();
    this._NgIf_25_6.check_ngIf(currVal_25_0_0,throwOnChange,false);
    this._NgIf_25_6.ngDoCheck(this,this._anchor_25,throwOnChange);
    const currVal_27_0_0:boolean = !this.context.getModal().isAdditionalPickupPointModal();
    this._NgIf_27_6.check_ngIf(currVal_27_0_0,throwOnChange,false);
    this._NgIf_27_6.ngDoCheck(this,this._anchor_27,throwOnChange);
    this._vc_21.detectChangesInNestedViews(throwOnChange);
    this._vc_23.detectChangesInNestedViews(throwOnChange);
    this._vc_25.detectChangesInNestedViews(throwOnChange);
    this._vc_27.detectChangesInNestedViews(throwOnChange);
    var tmp_44_0:any = (null as any);
    valUnwrapper.reset();
    const currVal_44:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(('modal.' + (((tmp_44_0 = this.context.getModal()) == null)? (null as any): tmp_44_0.getTitle())))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_44,currVal_44))) {
      this.renderer.setText(this._text_9,currVal_44);
      this._expr_44 = currVal_44;
    }
    var tmp_46_0:any = (null as any);
    valUnwrapper.reset();
    const currVal_46:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_1.transform(('modal.' + (((tmp_46_0 = this.context.getModal()) == null)? (null as any): tmp_46_0.getDescription())))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_46,currVal_46))) {
      this.renderer.setText(this._text_18,currVal_46);
      this._expr_46 = currVal_46;
    }
  }
  destroyInternal():void {
    this._vc_21.destroyNestedViews();
    this._vc_23.destroyNestedViews();
    this._vc_25.destroyNestedViews();
    this._vc_27.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 21)) { return new View_ModalComponent1(this.viewUtils,this,21,this._anchor_21,this._vc_21); }
    if ((nodeIndex == 23)) { return new View_ModalComponent2(this.viewUtils,this,23,this._anchor_23,this._vc_23); }
    if ((nodeIndex == 25)) { return new View_ModalComponent5(this.viewUtils,this,25,this._anchor_25,this._vc_25); }
    if ((nodeIndex == 27)) { return new View_ModalComponent6(this.viewUtils,this,27,this._anchor_27,this._vc_27); }
    return (null as any);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      $event.stopPropagation();
      const pd_sub_0:any = ((<any>this.context.getModal().hide(false)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      $event.stopPropagation();
      const pd_sub_0:any = ((<any>this.context.getModal().hide(false)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.getModal().hide(false)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_13(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>$event.stopPropagation()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/root/modal/modal.component.ngfactory.ts